import React from 'react';
import { Box, Container, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SiteHeader, { HeaderButton, HomeButton } from '../components/layout/SiteHeader';
import SiteFooter from '../components/layout/SiteFooter';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import landingBackground from '../assets/backgrounds/landingBackground.avif';
import ServiceLocator from '../components/ServiceLocator/ServiceLocator';
import { GOLDEN_MINOR } from '../styles/golden';
import { BRAND, frostedSx, primaryButtonSx } from '../styles/ui';

const Services: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        '@supports (min-height: 100dvh)': { minHeight: '100dvh' },
        backgroundColor: 'var(--joan-bg)',
        backgroundImage: `linear-gradient(to right, ${BRAND.veilStrong} ${GOLDEN_MINOR}, ${BRAND.veilSoft} 100%), url(${landingBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: { md: 'fixed' },
      }}
    >
      <SiteHeader
        actions={
          <>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <HomeButton />
            </Box>
            {isAuthenticated ? (
              <HeaderButton to="/profile" icon={<PersonOutlineIcon />}>My Profile</HeaderButton>
            ) : (
              <Button variant="contained" component={RouterLink} to="/register" sx={{ ...primaryButtonSx, px: { xs: 2, sm: 4 }, borderRadius: '50px', whiteSpace: 'nowrap' }}>
                Get Started
              </Button>
            )}
          </>
        }
      />

      {/* Main Content */}
      <Box component="main" sx={{ flex: 1, px: { xs: 2, sm: 3 }, py: { xs: 3, md: 5 } }}>
        <Container
          maxWidth="lg"
          sx={{
            py: { xs: 4, md: 5 },
            px: { xs: 3, sm: 4, md: 5 },
            ...frostedSx,
            backgroundColor: BRAND.card,
            border: `1px solid ${BRAND.line}`,
            borderRadius: '13px',
            boxShadow: BRAND.shadow,
          }}
        >
          <ServiceLocator />
        </Container>
      </Box>

      <SiteFooter />
    </Box>
  );
};

export default Services;
